/* eslint-disable react/prop-types */
import React from 'react';

import { Item } from './components/Item';

import './styles.scss';

export const SocialGrid = ({ mediaAssets }) => {
    if (!mediaAssets?.length) {
        return null;
    }

    return (
        <div className="social-grid">
            {mediaAssets.map((mediaAsset, index) => (
                <Item key={index} {...mediaAsset} />
            ))}
        </div>
    );
};
